/**
 * PATH: packages/email-hub/src/feature/pages/SentPage.tsx
 * FILE_ID: EMAILHUB-FEATURE-PAGES-SENTPAGE-001
 * PURPOSE: The Sent folder. Renders the SAME page as the Inbox
 *          (`InboxPage`) with `folder="sent"` — identical header chrome,
 *          list/reader split, auto-open first row and the full rich row
 *          toolkit. Sent just shows the recipient ("To: …") and drops
 *          self-junk; everything else is the Inbox frame, not a fork.
 * WHY:     Operator 2026-06-17: "copy the frame of inbox literally … we
 *          already have it." The old per-folder shell was a second,
 *          thinner layout that drifted from the Inbox (no auto-open, no
 *          filter chrome). One frame = no drift.
 * RELATED:
 *   - pages/InboxPage.tsx: the universal frame (accepts `folder`).
 *   - apps/<tenant>/src/features/email/pages/SentPage.tsx: thin re-export.
 */

import InboxPage from './InboxPage'

export default function SentPage() {
  return <InboxPage folder="sent" />
}
